import React, { useEffect } from "react";
import Typed from "typed.js";

const Banner = () => {
  useEffect(() => {
    const typeitInstance = new Typed(".is-visible", {
      strings: ["Mission.", "Vission", "History"],
      typeSpeed: 80,
      backSpeed: 60,
      startDelay: 200,
      loop: Infinity,
      showCursor: false,
    });

    return () => {
      typeitInstance.destroy();
    };
  }, []);

  return (
    <>
      <div className="row g-5 align-items-center">
        <div className="col-lg-10 offset-lg-1">
          <div className="content">
            <div className="inner text-center">
              <div className="rbt-new-badge rbt-new-badge-one">
                <span className="rbt-new-badge-icon">🏆</span> The Leader in
                bilingual education
              </div>

              <h1 className="title">
                Read About Our
                <span className="header-caption ms-2">
                  <span className="cd-headline clip is-full-width">
                    <span className="cd-words-wrapper">
                      <b className="is-visible theme-gradient"></b>
                    </span>
                  </span>
                </span>
              </h1>
              <p className="description has-medium-font-size mt--20">
                El Centro Educativo Menfis, nació hace veinticinco años con el objetivo de prestar el servicio educativo a los niños, niñas y jóvenes del municipio de Chinchiná desde una estrategia lúdico pedagógica fortaleciendo su ser para ejercer el hacer; hoy, ese objetivo sigue vigente, pero, con los requerimientos de pertinencia y oportunidad que demandan las condiciones sociales y económicas del siglo XXI. 
              </p>
              <p className="description has-medium-font-size mt--20">
                Por tanto, el Proyecto Educativo Institucional de Centro Educativo Menfis hoy presenta a la comunidad chinchinense una nueva propuesta educativa, en ella, el bilingüismo pasa a ser fundamental como diferenciador en nuestra oferta de servicio dirigida a las familias del municipio. 
              </p>
              <div className="slider-btn rbt-button-group justify-content-center">
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Banner;
